export enum DepositType {
    DEPOSIT = 1,    // Depósito
    TRANSFER = 2,   // Transferencia
    CASH = 3        // Efectivo
}